import React from 'react'

const TokenRegistrationTable = () => {
  return (
    <div>TokenRegistrationTable</div>
  )
}

export default TokenRegistrationTable